import { Typography, Stack, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../../components/button/CustomButton';
import { ReactComponent as ArrowRightIcon } from '../../../../assets/icons/project-icons/ArrowRightIcon.svg';
import { LAYOUT_DEFAULTS } from '../../../../utils/constants';
import { EnumPublicPagesImage } from '../../../../utils/enums';
import { getPublicImageUrl } from '../../../../utils/helpers';

const DoItYourself = () => {
  const navigate = useNavigate();

  return (
    // main row
    <Stack
      spacing={{ xs: 0, lg: 4 }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ ...LAYOUT_DEFAULTS, mb: 10 }}
    >
      {/* left column */}
      <Stack spacing={{ xs: 3, md: 6 }} sx={{ maxWidth: { xs: '100%', lg: '60%' } }}>
        <Typography sx={{ typography: { xs: 'publicHeading4', lg: 'publicHeading3' } }}>
          Prefer to do it yourself?
        </Typography>

        <Stack spacing={2}>
          <Typography variant="publicBody2Regular" color="common.black">
            🔹 Post your project
          </Typography>

          <Typography variant="publicBody4Regular" color="common.black">
            Use our guided project template to clearly outline your needs—scope, goals, budget, and
            timeline. It’s built to help you attract the right talent fast.
          </Typography>

          <Box
            src={getPublicImageUrl(EnumPublicPagesImage.DoItYourself)}
            component="img"
            sx={{ display: { xs: 'block', md: 'none' } }}
          />
        </Stack>

        <Stack spacing={2}>
          <Typography variant="publicBody2Regular" color="common.black">
            🔹Review and connect
          </Typography>

          <Typography variant="publicBody4Regular" color="common.black">
            You’ll receive tailored pitches from qualified service providers who match your brief.
            Chat with them via video or messaging directly on the platform.
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <Typography variant="publicBody2Regular" color="common.black">
            🔹Choose and start 
          </Typography>

          <Typography variant="publicBody4Regular" color="common.black">
            Pick your preferred service provider and start your project. Everything from contracts
            to communication is managed within Spona.
          </Typography>
        </Stack>

        <CustomButton
          onClick={() => navigate('./timed-projects')}
          sx={{ maxWidth: 'fit-content' }}
          endIcon={<ArrowRightIcon fill="#fff" />}
        >
          List a Project
        </CustomButton>
      </Stack>

      {/* right column */}
      <Box
        src={getPublicImageUrl(EnumPublicPagesImage.DoItYourself)}
        component="img"
        sx={{ display: { xs: 'none', md: 'block' }, mr: '-22px !important' }}
        alt="Illustration of the process for posting a project on Spona"
      />
    </Stack>
  );
};

export default DoItYourself;
